import React from 'react';
import NextButton from './NextButton';
import PrevButton from './PrevButton';
import { Container, Row, Col } from 'reactstrap';
import useSteps from '../StepContext/useSteps';
import ConfirmButton from './ConfirmButton';

const Footer: React.FC = () => {
  const { isLastStep } = useSteps();

  const renderConfirmAndNextBtn = () => {
    return isLastStep ? <ConfirmButton /> : <NextButton />;
  };

  return (
    <div className="sticky-footer">
      <Container>
        <Row>
          <Col md={{ size: 6, offset: 3 }}>
            <div className="d-none d-md-block">
              <div className="position-relative">
                <div className="d-flex">
                  <PrevButton />
                  {renderConfirmAndNextBtn()}
                </div>
              </div>
            </div>
            <div className="d-md-none">{renderConfirmAndNextBtn()}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
